// extracted by mini-css-extract-plugin
module.exports = {"header":"Form_header__jLAM4","note":"Form_note__L92ws","form":"Form_form__2XNcg","personalData":"Form_personalData__11CNX","button":"Form_button__H5EuJ"};